import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsMaintenanceCounter, PmsMaintenanceCounter } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsMaintenanceCounter>
    useData={usePmsMaintenanceCounter}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
